import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// English
import enCommon from './locales/en/common.json'
import enAuth from './locales/en/auth.json'
import enOnboarding from './locales/en/onboarding.json'
import enChat from './locales/en/chat.json'
import enNotebook from './locales/en/notebook.json'
import enSettings from './locales/en/settings.json'
import enBriefing from './locales/en/briefing.json'
import enCortex from './locales/en/cortex.json'
import enPlugins from './locales/en/plugins.json'
import enActivity from './locales/en/activity.json'
import enFollowups from './locales/en/followups.json'
import enRecording from './locales/en/recording.json'
import enMail from './locales/en/mail.json'
import enAdmin from './locales/en/admin.json'
import enDebug from './locales/en/debug.json'
import enFlag from './locales/en/flag.json'

// Swedish
import svCommon from './locales/sv/common.json'
import svAuth from './locales/sv/auth.json'
import svOnboarding from './locales/sv/onboarding.json'
import svChat from './locales/sv/chat.json'
import svNotebook from './locales/sv/notebook.json'
import svSettings from './locales/sv/settings.json'
import svBriefing from './locales/sv/briefing.json'
import svCortex from './locales/sv/cortex.json'
import svPlugins from './locales/sv/plugins.json'
import svActivity from './locales/sv/activity.json'
import svFollowups from './locales/sv/followups.json'
import svRecording from './locales/sv/recording.json'
import svMail from './locales/sv/mail.json'
import svAdmin from './locales/sv/admin.json'
import svDebug from './locales/sv/debug.json'
import svFlag from './locales/sv/flag.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        onboarding: enOnboarding,
        chat: enChat,
        notebook: enNotebook,
        settings: enSettings,
        briefing: enBriefing,
        cortex: enCortex,
        plugins: enPlugins,
        activity: enActivity,
        followups: enFollowups,
        recording: enRecording,
        mail: enMail,
        admin: enAdmin,
        debug: enDebug,
        flag: enFlag,
      },
      sv: {
        common: svCommon,
        auth: svAuth,
        onboarding: svOnboarding,
        chat: svChat,
        notebook: svNotebook,
        settings: svSettings,
        briefing: svBriefing,
        cortex: svCortex,
        plugins: svPlugins,
        activity: svActivity,
        followups: svFollowups,
        recording: svRecording,
        mail: svMail,
        admin: svAdmin,
        debug: svDebug,
        flag: svFlag,
      },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'sv'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // React handles escaping
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'tendbot-lang',
      caches: ['localStorage'],
    },
  })

export default i18n
